import React, {useRef} from 'react';
import {Button, Card, Col, Divider, Row, Table, Typography} from 'antd';
import {useReactToPrint} from 'react-to-print';
import {formatCurrency, formatCurrencyWithCurrencyCode, formatFrenchDate} from "../../../variables/functions";

const {Title, Text} = Typography;

const ReceiptTable = ({items, reglement, taxe, nomCompagnie}) => {
    const columns = [
        {title: 'Code Commande', dataIndex: 'codeId', key: 'codeId'},
        {title: 'Produit Code', dataIndex: ['produitAttestation', 'codeId'], key: 'produitCode'},
        {
            title: 'Produit',
            key: 'categorie',
            render: (_, record) => `${record.produitAttestation?.typeAttestation} ${record.produitAttestation?.categorie?.nom}`,
        },
        {title: 'Quantité', dataIndex: 'quantite', key: 'quantite'},
        {
            title: 'Montant Unitaire',
            dataIndex: ['produitAttestation', 'montant'],
            key: 'montant',
            render: (value) => formatCurrency(value),
        },
        {
            title: 'Total',
            key: 'total',
            render: (_, record) => formatCurrency((record.produitAttestation?.montant || 0) * (record.quantite || 0)),
        },
    ];

    const componentRef = useRef();
    const handlePrint = useReactToPrint({content: () => componentRef.current, documentTitle: 'Reçu'});
    const getTaxe = () => (reglement?.montant * taxe) / 100;

    const renderPaymentMethod = () => {
        const paymentMethods = {
            'CHEQUE': 'Chèque',
            'MOBILE_MONEY': 'Mobile Money'
        };
        return paymentMethods[reglement?.modePaiement] || reglement?.modePaiement || 'Non défini';
    };

    return (
        <div style={{maxWidth: 800, margin: 'auto', padding: 20, background: '#fff'}}>
            <Card ref={componentRef} bordered={false} style={{padding: 20}}>
                <Title level={3} style={{textAlign: 'center', marginBottom: 20}}>Reçu de Paiement
                    - {nomCompagnie}</Title>

                <Row justify="space-between" style={{marginBottom: 10}}>
                    <Col>
                        <Text strong>Date de Réglement: </Text>
                        <Text>{formatFrenchDate(reglement?.dateReglement)}</Text>
                    </Col>
                    <Col>
                        <Text strong>Moyen de Paiement: </Text>
                        <Text>{renderPaymentMethod()}</Text>
                    </Col>
                </Row>

                <Table dataSource={items} columns={columns} pagination={false} rowKey="codeId" bordered/>

                <Divider/>
                <Row justify="end">
                    <Col span={10}>
                        <Row justify="space-between">
                            <Col><Text strong>Montant Hors Taxe:</Text></Col>
                            <Col><Text strong>{formatCurrencyWithCurrencyCode(reglement?.montant)}</Text></Col>
                        </Row>
                        <Row justify="space-between">
                            <Col><Text strong>Taxe {taxe}% :</Text></Col>
                            <Col><Text strong>{formatCurrencyWithCurrencyCode(getTaxe())}</Text></Col>
                        </Row>
                        <Row justify="space-between">
                            <Col><Text strong>Montant TTC :</Text></Col>
                            <Col><Text
                                strong>{formatCurrencyWithCurrencyCode(reglement?.montant + getTaxe())}</Text></Col>
                        </Row>
                    </Col>
                </Row>
            </Card>

            <Button type="primary" onClick={handlePrint} style={{marginTop: 20, display: 'block', width: '100%'}}>
                Imprimer le Reçu
            </Button>
        </div>
    );
};

export default ReceiptTable;
